import {
    Box, Grid, GridItem, Heading, Link, Text, VStack, useBreakpointValue,
} from '@chakra-ui/react';
import { marketing } from '@acp/core-ui/assets';
import { CardLayout } from '../card-layout';

const collateralLink = 'https://www.detectorinspector.com.au/collateral/';
const gettingStartedLink = 'https://help.detectorinspector.com.au/hc/en-au/articles/5621766278159-Working-with-the-Agency-Portal';
const smokeAlarmTroubleshootingLink = 'https://www.detectorinspector.com.au/why-does-my-smoke-alarm-keep-going-off/';
const helpCentreLink = 'https://help.detectorinspector.com.au/hc/en-au';
const hotjarSurveyLink = import.meta.env.VITE_PUBLIC_FEEDBACK_SURVEY_URL;

export function MarketingTiles() {
    const gridColumns = useBreakpointValue({
        base: 'repeat(1, 1fr)',
        md: 'repeat(3, 1fr)',
    });
    const feedbackBoxMaxW = useBreakpointValue({
        base: '100%',
        lg: '85%',
    });

    return (
        <CardLayout px={{ base: 6, lg: 0 }} flexDir="row" alignItems="stretch" pt={0} pb={[4, null, 8]}>
            <Grid templateColumns={gridColumns} alignItems="stretch" gap={6}>
                <GridItem>
                    <Box
                        h="full"
                        w="full"
                        bg="white"
                        p={6}
                        backgroundImage={marketing.usingLaptopImg}
                        backgroundSize="cover"
                        backgroundRepeat="no-repeat"
                        backgroundPosition={['center', null, '40%']}
                    >
                        <Link
                            href={hotjarSurveyLink}
                            target="_blank"
                            textDecor="none"
                            _hover={{
                                textDecor: 'none',
                                cursor: (hotjarSurveyLink === undefined) ? 'default' : 'pointer',
                            }}
                        >
                            <Box bg="white" p={6} maxW={feedbackBoxMaxW}>
                                <Text fontSize="sm" color="muted.300" mb={4}>Feedback</Text>
                                <Text
                                    mb={{ lg: 8 }}
                                    textDecoration="none"
                                    textUnderlineOffset={5}
                                    lineHeight={1.5}
                                    _hover={{
                                        textDecoration: 'underline',
                                        textDecorationColor: '#9A9A9A',
                                        textDecorationThickness: '1px',
                                    }}
                                >
                                    We want to hear what you think.
                                    Share your insights to shape future releases.
                                </Text>
                            </Box>
                        </Link>
                    </Box>
                </GridItem>

                <GridItem>
                    <Link
                        href={collateralLink}
                        target="_blank"
                        textDecor="none"
                        _hover={{ textDecor: 'none' }}
                    >
                        <Box
                            minH={{ base: 'full', md: '530px' }}
                            bg="secondary.500"
                            py={{ base: 8, md: 16 }}
                            px={10}
                        >
                            <Heading
                                color="white"
                                variant="regular"
                                fontSize={{ base: 'xx-large', md: 'xxx-large' }}
                                fontWeight="normal"
                                lineHeight={1.3}
                                maxW={{ lg: 260 }}
                                _hover={{
                                    textDecor: 'underline',
                                    textDecorationThickness: '1px',
                                    textDecorationColor: 'white',
                                    textUnderlineOffset: { base: 8, md: 10 },
                                }}
                            >
                                Download the latest versions of brochures and flyers
                            </Heading>
                        </Box>
                    </Link>
                </GridItem>

                <GridItem>
                    <VStack h="full" gap={5}>
                        <Box h="50%" w="full" bg="white" flexGrow={1} p={6}>
                            <Text fontSize="sm" color="muted.300" mb={4}>Getting started</Text>
                            <Link
                                href={gettingStartedLink}
                                target="_blank"
                                textDecoration="none"
                                textUnderlineOffset={5}
                                lineHeight={1.5}
                                _hover={{
                                    textDecoration: 'underline',
                                    textDecorationColor: '#9A9A9A',
                                    textDecorationThickness: '1px',
                                }}
                            >
                                Find out how to use the Compliance Portal
                                effectively to make your compliance journey easier.
                            </Link>
                        </Box>

                        <Box h="50%" w="full" bg="white" flexGrow={1} p={6}>
                            <Text fontSize="sm" color="muted.300" mb={4}>Popular links</Text>
                            <VStack alignItems="start" gap={4}>
                                <Link
                                    textDecoration="underline"
                                    textDecorationColor="#9A9A9A"
                                    textDecorationThickness="1px"
                                    textUnderlineOffset={5}
                                    lineHeight={1.5}
                                    href={smokeAlarmTroubleshootingLink}
                                    target="_blank"
                                    _hover={{ textDecorationColor: 'black' }}
                                >
                                    Smoke Alarm Troubleshooting
                                </Link>
                                <Link
                                    textDecoration="underline"
                                    textDecorationColor="#9A9A9A"
                                    textDecorationThickness="1px"
                                    textUnderlineOffset={5}
                                    lineHeight={1.5}
                                    href={helpCentreLink}
                                    target="_blank"
                                    _hover={{ textDecorationColor: 'black' }}
                                >
                                    Have a question?
                                    <br />
                                    The answer is probably in our Help Centre
                                </Link>
                            </VStack>
                        </Box>
                    </VStack>
                </GridItem>
            </Grid>
        </CardLayout>
    );
}
